import { getImageUrl } from '../../utilities/getImageUrl';

export const RAW_GALLERY_DATA = {
  'lazy-susans': [
    // By Order Items
    // { name: 'Acacia Lazy Susan 9"', price: 50, image: getImageUrl('/images/gallery/lazy1.jpg'), availability: 'By Order Only' },
    // { name: 'Acacia Lazy Susan 11"', price: 120, image: getImageUrl('/images/gallery/lazy2.jpg'), availability: 'By Order Only' },
    // { name: 'Acacia Lazy Susan 12"', price: 150, image: getImageUrl('/images/gallery/lazy3.jpg'), availability: 'By Order Only' },
    // { name: 'Lazy Susan 14"', price: 120, image: getImageUrl('/images/gallery/lazy2.jpg'), availability: 'By Order Only' },
    // { name: 'Lazy Susan 15"', price: 150, image: getImageUrl('/images/gallery/lazy3.jpg'), availability: 'By Order Only' },
    
    // For Sale Items
    { name: 'Acacia Flower Lazy Susan 9" x .625"', price: 50, image: getImageUrl('/images/gallery/forSale/lzySu9-1.jpg'), availability: 'For Sale' },
    { name: 'Wave, Shell and Treasure Map Lazy Susan 14"x1"', price: 165, image: getImageUrl('/images/gallery/forSale/lazySu/20260130_110825.jpg'), availability: 'For Sale' },
    { name: 'Acacia Flower Lazy Susan 11" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/lzysu11-2.jpg'), availability: 'For Sale' },
    { name: 'Acacia Flower Lazy Susan 11" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/lzySu11-3.jpg'), availability: 'For Sale' },
    { name: 'Black Cherry Wave N Shell Lazy Susan 20"', price: 300, image: getImageUrl('/images/gallery/forSale/lzysu20-4.jpg'), availability: 'For Sale' },
    {
      name: 'Apple Flower Lazy Susan 14" x 1"',
      price: 165,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_131350.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1" thick, Material: Apple \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x .75" Wave Lazy Susan',
      price: 165,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135001.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x .75" thick, Material: Maple with Ocean Wave Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x .75" Wave Lazy Susan',
      price: 165,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135108.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x .75" thick, Material: Maple with Ocean Wave Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x 1" Wave Lazy Susan',
      price: 175,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135219.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1" thick, Material: Maple with Ocean Wave Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x 1" Wave Lazy Susan',
      price: 175,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135224.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1" thick, Material: Maple with Ocean Wave Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x 1" Floral Lazy Susan',
      price: 175,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135329.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1" thick, Material: Maple with Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Maple 14" x 1" Floral Lazy Susan',
      price: 175,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135334.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1" thick, Material: Maple with Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Cherry 14" x 1.15" Floral Lazy Susan',
      price: 185,
      image: getImageUrl('/images/gallery/forSale/lazySu/20260130_135518.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter x 1.15" thick, Material: Maple with Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only' 
    },
    {
      name: 'Acacia 15" Wave N Shell Lazy Susan',
      price: 130,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210020.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/lazySu/20251120_210020.jpg'),
        getImageUrl('/images/gallery/forSale/lazySu/20251120_210053.jpg'),
        getImageUrl('/images/gallery/forSale/lazySu/20251120_210130.jpg')
      ],
      description: 'Dimensions: 15" Diameter, Material: Acacia with Ocean Wave & Shell Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Acacia 11" Floral Lazy Susan',
      price: 85,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210244.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 11" Diameter, Material: Acacia with Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Acacia 11" Floral Lazy Susan',
      price: 85,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210342.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 11" Diameter, Material: Acacia with Sunflower Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Maple 14" Wine Cork N Floral Lazy Susan',
      price: 145,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210459.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter, Material: Acacia with Wine Cork & Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Maple 14" Floral Lazy Susan',
      price: 135,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210600.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/lazySu/20251120_210600.jpg'),
        getImageUrl('/images/gallery/forSale/lazySu/20251120_210642.jpg')
      ],
      description: 'Dimensions: 14" Diameter, Material: Acacia with Purple Hydrangea & Daisy Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Maple 14" Floral Lazy Susan',
      price: 165,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210832.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 14" Diameter, Material: Acacia with Rose & Daisy Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Acacia 11" Floral Lazy Susan',
      price: 85,
      image: getImageUrl('/images/gallery/forSale/lazySu/20251120_210959.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 11" Diameter, Material: Acacia with Pastel Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
  ],
  'wave-cutting-boards': [
    // By Order Items
    // {
    //   name: 'Black Walnut 11" x 8 " ',
    //   price: 65,
    //   image: getImageUrl('/images/gallery/board1.jpg'),
    //   availability: 'By Order Only',
    //   images: [
    //     getImageUrl('/images/gallery/river1.jpg'),
    //     getImageUrl('/images/gallery/river1-angle1.jpg'),
    //     getImageUrl('/images/gallery/river1-angle2.jpg'),
    //     getImageUrl('/images/gallery/river1-detail.jpg')
    //   ],
    //   description: 'Dimensions: 0.57" H x 19.45" W x 7.78" D HEY Material: Acacia Wood \n\n Care & Safety: Food Safe; Hand Wash Only' 
    // },
    // { name: 'Black Walnut 14" x 8"', price: 95, image: getImageUrl('/images/gallery/board2.jpg'), availability: 'By Order Only' },
    // { name: 'Black Walnut 19" x 10" ', price: 75, image: getImageUrl('/images/gallery/board3.jpg'), availability: 'By Order Only' },
    // { name: 'Black Walnut 24" x 12"', price: 95, image: getImageUrl('/images/gallery/board2.jpg'), availability: 'By Order Only' },
    // { name: 'Black Walnut 32" x 8.5" ', price: 75, image: getImageUrl('/images/gallery/board3.jpg'), availability: 'By Order Only' },
    // { name: 'Maple Walnut 11" x 8 " ', price: 65, image: getImageUrl('/images/gallery/board1.jpg'), availability: 'By Order Only' },
    // { name: 'Maple Walnut 14" x 8"', price: 95, image: getImageUrl('/images/gallery/board2.jpg'), availability: 'By Order Only' },
    // { name: 'Maple Walnut 19" x 10" ', price: 75, image: getImageUrl('/images/gallery/board3.jpg'), availability: 'By Order Only' },
    // { name: 'Maple Walnut 24" x 12"', price: 95, image: getImageUrl('/images/gallery/board2.jpg'), availability: 'By Order Only' },
    // { name: 'Maple Walnut 32" x 8.5" ', price: 75, image: getImageUrl('/images/gallery/board3.jpg'), availability: 'By Order Only' },
    // // For Sale Items
    { name: 'Acacia Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152728.jpg'), availability: 'For Sale' },
    { name: 'Acacia Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152602.jpg'), availability: 'For Sale' },
    { name: 'Acacia Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/acWaveBoard5.jpg'), availability: 'For Sale' },
    { name: 'Acacia Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152241.jpg'), availability: 'For Sale' },
    { name: 'Acacia Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152345.jpg'), availability: 'For Sale' },
    { name: 'Acacia Dark Blue Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152517.jpg'), availability: 'For Sale' },
    { name: 'Acacia Turquoise Wave N Shell 19.5" x 8" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152433.jpg'), availability: 'For Sale' },
    { name: 'Black Walnut Wave N Shell 32" x 8.5"', price: 165, image: getImageUrl('/images/gallery/forSale/20251126_145901.jpg'), availability: 'For Sale' },
    { name: 'Black Walnut Wave N Shell 32" x 8.5"', price: 165, image: getImageUrl('/images/gallery/forSale/20251126_150154.jpg'), availability: 'For Sale' },
    {name: 'Cherry Double Sided Wave Board 21" x 9.5" x 1"', price: 145, image: getImageUrl('/images/gallery/forSale/20251126_151110.jpg'), availability: 'For Sale' },
    {
      name: 'Maple 22.5" x 13.5" x 1.5" Wave N Shell Cutting Board',
      price: 195,
      image: getImageUrl('/images/gallery/forSale/wave-boards/20260130_132300.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/wave-boards/20260130_132309.jpg'),
        getImageUrl('/images/gallery/forSale/waveCuttingBoards/20260130_132309.jpg')
      ],
      description: 'Dimensions: 22.5" x 13.5" x 1.5", Material: Maple with Ocean Wave & Shell Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Black Walnut 21.5" x 12.5" x 1.25" Wave N Shell Cutting Board',
      price: 185,
      image: getImageUrl('/images/gallery/forSale/wave-boards/20260130_132427.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/wave-boards/20260130_132431.jpg'),
      ],
      description: 'Dimensions: 21.5" x 12.5" x 1.25", Material: Black Walnut with Turquoise Ocean Wave & Shell Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Black Walnut 22" x 12" x 1" Wave N Shell Cutting Board',
      price: 175,
      image: getImageUrl('/images/gallery/forSale/wave-boards/20260130_133459.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 22" x 12" x 1", Material: Black Walnut with Blue Ocean Wave & Shell Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Cherry 13.25" x 6.25" x 1" Wave Cutting Board',
      price: 95,
      image: getImageUrl('/images/gallery/forSale/wave-boards/20260130_134000.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 13.25" x 6.25" x 1", Material: Cherry with Ocean Wave Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
  ],
  'floral': [
    // By Order Items
    { name: 'Black Walnut Floral Cutting Board 26"x12"x1.5" ', price: 275, image: getImageUrl('/images/gallery/forSale/BlackWalnut_Cuttingboard.png'), availability: 'By Order Only' },
    { name: 'Acacia Floral Cutting Board 19.5"x7.75"x.625" ', price: 75, image: getImageUrl('/images/gallery/byOrder/flower-board/arcadia_cuttingboard.jpeg'), availability: 'By Order Only' },
    // For Sale Items
    { name: 'Black Walnut Cork N Flower 23" x 10" x 1"', price: 135, image: getImageUrl('/images/gallery/forSale/bwflr.jpg'), availability: 'For Sale',
        images: getImageUrl(['/images/gallery/forSale/bwflr.jpg', '/images/gallery/forSale/20251126_150600.jpg'])
     },
    { name: 'Black Walnut Flower Board 25.5" x 9" x 1"', price: 135, image: getImageUrl('/images/gallery/forSale/bwflr1.jpg'), availability: 'For Sale' },
    { name: 'Acacia Flower Board 19.5" x 7.75" x .625"', price: 75, image: getImageUrl('/images/gallery/forSale/20251126_152117.jpg'), availability: 'For Sale' },
    { name: 'Acacia Flower Board 25.5" x 9 x 1"', price: 135, image: getImageUrl('/images/gallery/forSale/bwflr1.jpg'), availability: 'For Sale' },
    {name: 'Maple Cork N Flower Board 22" x 7.25" x 1"', price: 135, image: getImageUrl('/images/gallery/forSale/20251126_150822.jpg'), availability: 'For Sale', images: getImageUrl(['/images/gallery/forSale/20251126_150822.jpg','/images/gallery/forSale/20251126_150853.jpg'])},
    {name: 'Maple Flower Board 20" x 8.5" x 1"', price: 115, image: getImageUrl('/images/gallery/forSale/20251126_151016.jpg'), availability: 'For Sale'},
    {name: 'Black Walnut Flower Board 22.5" x 7" x 1"', price: 115, image: getImageUrl('/images/gallery/forSale/20251126_151238.jpg'), availability: 'For Sale'},
    {name: 'Black Cherry Flower Board 21" x 8" x 1"', price: 115, image: getImageUrl('/images/gallery/forSale/20251126_151907.jpg'), availability: 'For Sale'},
    {
      name: 'Maple Wine Cork N Floral Cutting Board 8" x 20" x 1"',
      price: 130,
      image: getImageUrl('/images/gallery/forSale/floural/20260130_130600.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/floural/20260130_130600.jpg'),
        getImageUrl('/images/gallery/forSale/floural/20260130_130616.jpg')
      ],
      description: 'Dimensions: 8" x 20" x 1", Material: Acacia with Wine Cork & Purple Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Black Walnut Floral Cutting Board 20" x 8" x 1"',
      price: 125,
      image: getImageUrl('/images/gallery/forSale/floural/20260130_130852.jpg'),
      availability: 'For Sale',
      description: 'Dimensions: 20" x 8" x 1", Material: Black Walnut with Pink Daisy Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Maple Sunflower Cutting Board',
      price: 350,
      image: getImageUrl('/images/gallery/forSale/floural/20260118_160820.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/floural/20260118_160820.jpg'),
        getImageUrl('/images/gallery/forSale/floural/IMG_20260118_215300.jpeg')
      ],
      description: 'Material: Maple with Double Sunflower Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Black Walnut Wine Cork N Floral Cutting Board 20.5" x 7" x 1.5"',
      price: 120,
      image: getImageUrl('/images/gallery/forSale/floural/20260130_131652.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/floural/20260130_131652.jpg'),
        getImageUrl('/images/gallery/forSale/floural/20260130_131646.jpg')
      ],
      description: 'Dimensions: 20.5" x 7" x 1.5", Material: Black Walnut with Wine Cork & Rose Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
    {
      name: 'Acacia Black Floral Cutting Board 19.5" x 8" x .5"',
      price: 95,
      image: getImageUrl('/images/gallery/forSale/floural/20260130_133722.jpg'),
      availability: 'For Sale',
      images: [
        getImageUrl('/images/gallery/forSale/floural/20260130_133722.jpg'),
        getImageUrl('/images/gallery/forSale/floural/20260130_133714.jpg')
      ],
      description: 'Dimensions: 19.5" x 8" x .5", Material: Acacia with Black Epoxy & Vibrant Floral Design \n\n Care & Safety: Food Safe; Hand Wash Only'
    },
  ],
  'scene-boards': [
    // By Order Items
    //For Sale
    { name: 'Poker Scene Acacia Cutting Board 20"x10"x1"', price: 120, image: getImageUrl('/images/gallery/forSale/scenes/20260130_133131.jpg'), availability: 'For Sale', images: [getImageUrl('/images/gallery/forSale/scenes/20260130_133143.jpg')] },
    { name: 'Poker And Bison 20" x 10" x 1" Acacia Cutting Board', price: 120, image: getImageUrl('/images/gallery/forSale/scenes/20260130_133302.jpg'), availability: 'For Sale', images: [getImageUrl('/images/gallery/forSale/scenes/20260130_133307.jpg')] },
    { name: 'Acacia Fence N Flower Board 19.5" x 8" x .625"', price: 80, image: getImageUrl('/images/gallery/forSale/20251126_152641.jpg'), availability: 'For Sale' },
    { name: 'Acacia Poker Board 19.5" x 8" x .625"', price: 80, image: getImageUrl('/images/gallery/forSale/acaciapoker.jpg'), availability: 'For Sale' },
    { name: 'Black Walnut Bison Cutting Board 31.5" x 7.5" x 1"', price: 135, image: getImageUrl('/images/gallery/forSale/20251126_151636.jpg'), availability: 'For Sale' },
    { name: 'Acacia Cards N Money Board 19.5" x 8" x .625"', price: 60, image: getImageUrl('/images/gallery/forSale/20251126_153009.jpg'), availability: 'For Sale' },
  ],
  'river-boards': [
    // By Order Items
    // { name: 'Blue River Board', price: 180, image: getImageUrl('/images/gallery/river1.jpg'), availability: 'By Order Only' },
    // { name: 'Green Wave Board', price: 165, image: getImageUrl('/images/gallery/river2.jpg'), availability: 'By Order Only' },
    // For Sale Items
    // { name: 'Turquoise River Board', price: 115, image: getImageUrl('/images/gallery/river3.jpg'), availability: 'For Sale' },
  ],
  'tables': [
    // By Order Items
    { name: 'Ocean River Table', price: 1200, image: getImageUrl('/images/gallery/IMG_1692.jpg'), availability: 'By Order Only' },
    // { name: 'Lake River Table', price: 950, image: getImageUrl('/images/gallery/rivertable2.jpg'), availability: 'By Order Only' },
    // For Sale Items
    // { name: 'Sky River Table', price: 1100, image: getImageUrl('/images/gallery/rivertable3.jpg'), availability: 'For Sale' },
  ],
  'skulls': [
    // By Order Items
    { name: 'Xtra Large Epoxy Skull', price: 20, image: getImageUrl('/images/gallery/skull1.jpg'), availability: 'By Order Only' },
    { name: 'Large Epoxy Skull ', price: 110, image: getImageUrl('/images/gallery/skull2.jpg'), availability: 'By Order Only' },
    { name: 'Medium Epoxy Skull', price: 85, image: getImageUrl('/images/gallery/skull1.jpg'), availability: 'By Order Only' },
    { name: 'Small Epoxy Skull', price: 110, image: getImageUrl('/images/gallery/skull2.jpg'), availability: 'By Order Only' },
    // For Sale Items
    { name: 'Wooden Skull', price: 90, image: getImageUrl('/images/gallery/skull3.jpg'), availability: 'For Sale' },
  ],
  'animals': [
    // By Order Items
    { name: 'Large Epoxy Cat', price: 95, image: getImageUrl('/images/gallery/animal1.jpg'), availability: 'By Order Only' },
    { name: 'Medium Epoxy Cat', price: 135, image: getImageUrl('/images/gallery/animal2.jpg'), availability: 'By Order Only' },
    { name: 'Small Epoxy Cat', price: 135, image: getImageUrl('/images/gallery/animal2.jpg'), availability: 'By Order Only' },
    { name: 'Large Epoxy Dog', price: 95, image: getImageUrl('/images/gallery/animal1.jpg'), availability: 'By Order Only' },
    { name: 'Medium Epoxy Dog', price: 135, image: getImageUrl('/images/gallery/animal2.jpg'), availability: 'By Order Only' },
    { name: 'Small Epoxy Dog', price: 135, image: getImageUrl('/images/gallery/animal2.jpg'), availability: 'By Order Only' },
    // For Sale Items
    { name: 'Wolf Carving', price: 105, image: getImageUrl('/images/gallery/animal3.jpg'), availability: 'For Sale' },
  ],
  'coasters': [
    // By Order Items
    { name: '4 count Fence And Flower Coasters Set With Holder', price: 40, image: getImageUrl('/images/gallery/byOrder/coasters/IMG_2158.jpg'), availability: 'For Sale' },
    { name: '4 count - Octagon Wave Coaster 3.5" wide', price: 40, image: getImageUrl('/images/gallery/forSale/coasters/20260130_140034.jpg'), availability: 'For Sale' },
    { name: '5 Pack Square Wave Coaster 3.5"', price: 50, image: getImageUrl('/images/gallery/forSale/coasters/20260130_135841.jpg'), availability: 'For Sale' },
    { name: '4 pack Round Flower Coasters 3.5"', price: 40, image: getImageUrl('/images/gallery/forSale/coasters/20251116_132221.jpg'), availability: 'By Order Only' },
  
  ],
  'holidays': [
    // By Order Items
    { name: 'Christmas Winter Scene', price: 140, image: getImageUrl('/images/gallery/forSale/holiday/20260130_131925.jpg'), availability: 'For Sale', images: [
      getImageUrl('/images/gallery/forSale/holiday/20260130_131957.jpg', )
    ], description: 'Christmas Winter Wonderland including fake snow, candy canes, rein deer, angels, reefs, trees' },
    { name: 'Acacia Christmas Theme Cutting Board', price: 75, image: getImageUrl('/images/gallery/forSale/holiday/20260130_133919.jpg'), availability: 'For Sale', description: 'Snow man, Santa, Christmas Tree and snow with a star filled night sky ' },
  ],
  'other': [
    { name: 'Sea Shell Soap Holder', price: 25, image: getImageUrl('/images/gallery/forSale/bathroom/20251116_131709.jpg'), availability: 'For Sale',   },
    { name: 'Floral Soap Holder', price: 25, image: getImageUrl('/images/gallery/forSale/bathroom/20251116_131717.jpg'), availability: 'For Sale' },
    { name: 'Trinket Trays  1pc', price: 25, image: getImageUrl('/images/gallery/forSale/bathroom/20251116_131625(1).jpg'), availability: 'For Sale', images: [
      getImageUrl('/images/gallery/forSale/bathroom/20251116_131610.jpg', getImageUrl('/images/gallery/forSale/bathroom/20251116_131509.jpg'))
    ], description: 'Many various trinket tray styles.  Per 1 is 25$.'},
  ],
};